module.exports = __webpack_public_path__ + "static/mlh-trust-badge-2023-white-00636c8dd15082c5eab0921d4731a7f3.svg";